// <product-page> — variant picker, gallery sync, sticky buy bar, add to cart.
class ProductPage extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.dataset.product);
    this.autoAddVariantId = this.dataset.autoAddVariantId || '';
    this.optionGroups = Array.from(this.querySelectorAll('[data-option-index]'));
    this.galleryImgs = Array.from(this.querySelectorAll('.gallery-main img, .gallery-main video'));
    this.thumbs = Array.from(this.querySelectorAll('.gallery-thumbs button'));
    this.priceEl = this.querySelector('[data-price]');
    this.comparePriceEl = this.querySelector('[data-compare-price]');
    this.availabilityEl = this.querySelector('[data-availability]');
    this.variantIdInput = this.querySelector('[data-variant-id]');
    this.submitBtn = this.querySelector('[data-submit-btn]');
    this.form = this.querySelector('[data-buy-form]');
    this.qtyInput = this.querySelector('[data-qty-input]');
    this.qtyDecrease = this.querySelector('[data-qty-decrease]');
    this.qtyIncrease = this.querySelector('[data-qty-increase]');
    this.addonCheckboxes = Array.from(this.querySelectorAll('[data-addon-checkbox]'));
    this.errorEl = null;

    if (this.qtyDecrease) this.qtyDecrease.addEventListener('click', this.onQtyStep.bind(this, -1));
    if (this.qtyIncrease) this.qtyIncrease.addEventListener('click', this.onQtyStep.bind(this, 1));
    if (this.qtyInput) this.qtyInput.addEventListener('change', this.onQtyChange.bind(this));

    var firstAvailable = this.variants.find(function (v) { return v.available; }) || this.variants[0];
    this.selected = firstAvailable.options.slice();

    this.optionGroups.forEach(function (group) {
      group.querySelectorAll('button[data-value]').forEach(function (btn) {
        btn.addEventListener('click', this.onOptionClick.bind(this));
      }.bind(this));
    }.bind(this));

    this.thumbs.forEach(function (btn) {
      btn.addEventListener('click', this.onThumbClick.bind(this));
    }.bind(this));

    if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

    this.render();
    this.initStickyBar();
  }

  onQtyStep(delta) {
    var current = parseInt(this.qtyInput.value, 10);
    if (isNaN(current) || current < 1) current = 1;
    this.qtyInput.value = Math.max(1, current + delta);
  }

  onQtyChange() {
    var current = parseInt(this.qtyInput.value, 10);
    if (isNaN(current) || current < 1) current = 1;
    this.qtyInput.value = current;
  }

  onOptionClick(e) {
    var btn = e.currentTarget;
    var index = parseInt(btn.closest('[data-option-index]').dataset.optionIndex, 10);
    this.selected[index] = btn.dataset.value;
    this.render();
  }

  onThumbClick(e) {
    var mediaId = e.currentTarget.dataset.mediaId;
    this.showMedia(mediaId);
  }

  showMedia(mediaId) {
    if (!mediaId || mediaId === 'null') return;
    this.galleryImgs.forEach(function (el) {
      var isMatch = String(el.dataset.mediaId) === String(mediaId);
      el.classList.toggle('on', isMatch);
      if (el.tagName === 'VIDEO' && !isMatch && !el.paused) el.pause();
    });
    this.thumbs.forEach(function (btn) { btn.classList.toggle('active', String(btn.dataset.mediaId) === String(mediaId)); });
  }

  findVariant() {
    var selected = this.selected;
    return this.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    });
  }

  render() {
    var self = this;
    var variant = this.findVariant();

    this.optionGroups.forEach(function (group) {
      var index = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('button[data-value]').forEach(function (btn) {
        var isActive = btn.dataset.value === self.selected[index];
        btn.classList.toggle('active', isActive);
        var trial = self.selected.slice();
        trial[index] = btn.dataset.value;
        var exists = self.variants.some(function (v) { return v.options.every(function (val, i) { return val === trial[i]; }); });
        btn.disabled = !exists;
      });
    });

    if (!variant) return;

    if (this.priceEl) this.priceEl.textContent = variant.price_formatted;
    if (this.comparePriceEl) {
      if (variant.compare_at_formatted) {
        this.comparePriceEl.textContent = variant.compare_at_formatted;
        this.comparePriceEl.hidden = false;
      } else {
        this.comparePriceEl.hidden = true;
      }
    }
    if (this.availabilityEl) this.availabilityEl.textContent = variant.available ? 'Taxes included.' : 'Sold out, this colourway';
    if (this.variantIdInput) this.variantIdInput.value = variant.id;
    if (this.submitBtn) {
      this.submitBtn.disabled = !variant.available;
      this.submitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    this.showMedia(variant.featured_image_id);

    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
  }

  showError(message) {
    if (!this.errorEl) {
      this.errorEl = document.createElement('div');
      this.errorEl.className = 'pdp-add-error';
      this.errorEl.setAttribute('role', 'alert');
      if (this.form) this.form.appendChild(this.errorEl);
    }
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  }

  clearError() {
    if (this.errorEl) this.errorEl.hidden = true;
  }

  onSubmit(e) {
    e.preventDefault();
    var variant = this.findVariant();
    if (!variant || !variant.available) return;
    var qty = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    var items = [{ id: variant.id, quantity: qty }];
    if (this.autoAddVariantId) {
      var autoAddId = parseInt(this.autoAddVariantId, 10);
      if (autoAddId) {
        // Tag the free gift with the Dresser's own variant id so the cart page
        // and mini-cart drawer can find and remove it again if the Dresser
        // itself is later removed (see reconcileAutoGifts in
        // module-add-to-cart.js and mini-cart-drawer.js).
        items.push({
          id: autoAddId,
          quantity: qty,
          properties: { _auto_gift_of: String(variant.id) }
        });
      }
    }
    this.addonCheckboxes.forEach(function (cb) {
      if (cb.checked && !cb.disabled) {
        var addonId = parseInt(cb.dataset.addonVariantId, 10);
        if (addonId) items.push({ id: addonId, quantity: 1 });
      }
    });
    var self = this;
    this.clearError();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          self.showError(result.data.message || result.data.description || 'Sorry, something went wrong adding this to your cart. Please try again.');
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (self.qtyInput) self.qtyInput.value = 1;
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        self.showError('Sorry, something went wrong adding this to your cart. Please try again.');
      });
  }

  initStickyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var addBtn = document.querySelector('[data-sticky-add]');
    var self = this;
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var r = self.getBoundingClientRect();
      bar.classList.toggle('show', r.bottom < 0);
    }, { passive: true });
    if (addBtn) addBtn.addEventListener('click', function () { self.scrollIntoView({ behavior: 'smooth' }); });
  }
}
customElements.define('product-page', ProductPage);
